
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import baseURL from "./baseURL/BaseURL";
import logo1 from "../../assets/images/logo1.svg";
import { ToastContainer, toast } from "react-toastify";
import IntlTelInput from "intl-tel-input/reactWithUtils";
import "intl-tel-input/styles";
import "react-toastify/dist/ReactToastify.css";
import signup_image from "../../assets/images/signup_image(1).jpg"
import SelectController from "../reusableComponents/SelectController";

const TermsModal = ({ isOpen, onClose, onConfirm }) => {
  const [isAgreed, setIsAgreed] = useState(false);
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-lg max-w-2xl w-full max-h-[90vh] overflow-hidden">
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-3xl font-semibold font-sans text-[#730000]">Confirm Register</h2>
        </div>

        <div className="p-6 overflow-y-auto max-h-96">
          <p className="text-gray-700 leading-relaxed">
            By signing up on <strong>Select Proposal</strong>, you acknowledge and agree that while our
            platform implements initial screening procedures to maintain the quality and integrity of
            profiles, the ultimate responsibility for verifying the authenticity, background, and
            intentions of other users lies with you. We strongly encourage all members to conduct
            their own due diligence before proceeding with any form of communication, engagement,
            or commitment.
          </p>
          <br />
          <p className="text-gray-700 leading-relaxed">
            <strong>Select Proposal</strong> is not liable for any misrepresentation, misconduct,
            or disputes arising from interactions or connections made through the platform.
          </p>
        </div>

        <div className="p-6 border-t border-gray-200">
          <div className="flex items-center mb-4">
            <input
              type="checkbox"
              id="terms-checkbox"
              checked={isAgreed}
              onChange={(e) => setIsAgreed(e.target.checked)}
              className="mr-3 h-4 w-4 text-[#730000] focus:ring-[#730000] border-gray-300 rounded"
            />
            <label htmlFor="terms-checkbox" className="text-sm text-gray-700">
              I have read and agree to the terms and conditions
            </label>
          </div>

          <div className="flex gap-3 justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              disabled={!isAgreed}
              className={`px-6 py-2 rounded-md font-semibold transition-colors ${isAgreed
                ? "bg-[#730000] text-white hover:bg-[#5a0000]"
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
                }`}
            >
              Confirm Registration
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const SignUpScreen = () => {
  const navigate = useNavigate();
  const [countries, setCountries] = useState([]);
  const [refferals, setRefferals] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [cities, setCities] = useState([]);
  const [startAnimation, setStartAnimation] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  // Add errors state
  const [errors, setErrors] = useState({});

  // Field labels mapping for better error messages
  const fieldLabels = {
    first_name: "First Name",
    last_name: "Last Name",
    email: "Email",
    occupation: "Occupation",
    show_name: "Show Name",
    income: "Monthly Income",
    gender: "Gender",
    title: "Title",
    feet: "Height (Feet)",
    inch: "Height (Inches)",
    marital_status: "Marital Status",
    caste: "Caste",
    look: "Complexion",
    education: "Education",
    religion: "Religion",
    mobile: "Mobile Number",
    you_are: "You Are",
    world_country_id: "Country",
    world_division_id: "State",
    world_city_id: "City",
    dob: "Date of Birth",
    password: "Password",
    password_confirmation: "Confirm Password"
  };

  useEffect(() => {
    setTimeout(() => {
      setStartAnimation(true);
    }, 1000);
  }, []);

  const handleAnimationEnd = () => {
    setIsHidden(true);
    setTimeout(() => {
      setShowForm(true);
    }, 500);
  };
  const [formData, setFormData] = useState({
    show_name: "",
    first_name: "",
    last_name: "",
    email: "",
    gender: "",
    occupation: "",
    income: "",
    password: "",
    password_confirmation: "",
    title: "",
    description: "",
    feet: "",
    inch: "",
    marital_status: "",
    caste: "",
    referred_by: "",
    look: "",
    education: "",
    religion: "",
    mobile: "",
    you_are: "",
    world_country_id: "",
    world_division_id: "",
    world_city_id: "",
    dob: "",
    age: "",
  });
  const enumData = {
    show_name: { show_yes: "Yes - Display my name publicly", show_no: "No - Hidden Name" },
    gender: { male: "Male", female: "Female" },
    marital_status: {
      single: "Single",
      married: "Married (Polygamy)",
      widow: "Widow (Husband Died)",
      widower: "Widower (Wife Died)",
      divorced: "Divorced",
      separated: "Separated",
    },
    look: {
      very_fair: "Very Fair",
      fair: "Fair",
      medium: "Medium",
      dark: "Dark",
    },
    education: {
      bachelors: "Bachelors (B.A/BSc/BBA)",
      graduation: "Graduation",
      engineering: "Engineering Degree",
      masters: "Masters (M.A/MSc/MBA)",
      medical: "Medical Doctor (MD/MBBS)",
      phd: "Doctrate (PHD)",
      exception: "Exception"
    },
    occupation: {
      doctor: "Doctor",
      engineer: "Engineer",
      css_officer: "CSS Officer",
      cyber_security: "Cyber Security",
      teacher: "Teacher",
      business_man: "Business Man",
      armed_forces: "Armed Forces",
      accountant: "Accountant",
      acting_professional: "Acting Professional",
      actor_actress: "Actor / Actress",
      administration_professional: "Administration Professional",
      advertising_visualiser: "Advertising Visualiser",
      air_hostess: "Air Hostess",
      architect: "Architect",
      artist: "Artist",
      audiologist: "Audiologist",
      banker: "Banker",
      beautician: "Beautician",
      biologist: "Biologist",
      botanist: "Botanist",
      chartered_accountant: "Chartered Accountant",
      civil_engineer: "Civil Engineer",
      clerical_official: "Clerical Official",
      commercial_pilot: "Commercial Pilot",
      company_secretary: "Company Secretary",
      computer_professional: "Computer Professional",
      consultant: "Consultant",
      contractor: "Contractor",
      cost_accountant: "Cost Accountant",
      creative_person: "Creative Person",
      customer_support_professional: "Customer Support Professional",
      dentist: "Dentist",
      designer: "Designer",
      doctor: "Doctor",
      economist: "Economist",
      engineer: "Engineer",
      entertainment_professional: "Entertainment Professional",
      executive: "Executive",
      factory_worker: "Factory Worker",
      farmer: "Farmer",
      fashion_designer: "Fashion Designer",
      finance_professional: "Finance Professional",
      flight_attendant: "Flight Attendant",
      government_employee: "Government Employee",
      health_care_professional: "Health Care Professional",
      home_maker: "Home Maker",
      hotel_restaurant_professional: "Hotel / Restaurant Professional",
      interior_designer: "Interior Designer",
      investment_professional: "Investment Professional",
      it_telecom_professional: "IT / Telecom Professional",
      journalist: "Journalist",
      lawyer_legal_professional: "Lawyer / Legal Professional",
      manager: "Manager",
      marketing_professional: "Marketing Professional",
      media_professional: "Media Professional",
      medical_professional: "Medical Professional",
      military: "Military",
      not_working: "Not Working",
      nurse: "Nurse",
      odd_jobs_part_time: "Odd Jobs / Part Time",
      online_merchant: "Online Merchant",
      optician: "Optician",
      pharmacist: "Pharmacist",
      physicist: "Physicist",
      physiotherapist: "Physiotherapist",
      pilot: "Pilot",
      politician: "Politician",
      professor_teacher: "Professor / Teacher",
      psychologist: "Psychologist",
      public_relations_professional: "Public Relations Professional",
      real_estate_professional: "Real Estate Professional",
      research_scholar: "Research Scholar",
      retired_person: "Retired Person",
      sales_professional: "Sales Professional",
      scientist: "Scientist",
      self_employed: "Self-Employed",
      social_worker: "Social Worker",
      software_consultant: "Software Consultant",
      sports_athlete: "Sports / Athlete",
      student: "Student",
      teacher: "Teacher",
      technician: "Technician",
      training_professional: "Training Professional",
      unspecified: "Unspecified",
      veterinary_doctor: "Veterinary Doctor",
      volunteer: "Volunteer",
      writer: "Writer",
      zoologist: "Zoologist",
      css_officer: "CSS Officer",
      cyber_security: "Cyber Security",
      business_man: "Business Man",
      armed_forces: "Armed Forces",
      other: "Other",
    },
    religion: {
      islam: "Islam",
      christianity: "Christianity",
      hinduism: "Hinduism",
      buddhism: "Buddhism",
      sikhism: 'Sikhism',
      jainism: 'Jainism',
      bahai: 'Baháʼí Faith',
      zoroastrianism: 'Zoroastrianism',
      confucianism: 'Confucianism',
      taoism: 'Taoism',
      spiritism: 'Spiritism',
    },
    you_are: { self: "Self", parent_guardian: "Parent/Guardian", cousin: "Cousin", sibling: "Sibling", friend: "Friend" }
  };
  const enumToOptions = (enumObj) =>
    Object.entries(enumObj).map(([value, label]) => ({ value, label }));
  const feetOptions = Array.from({ length: 5 }, (_, i) => i + 3)
    .map(num => ({ value: num.toString(), label: num.toString() }));
  const inchOptions = Array.from({ length: 12 }, (_, i) => i + 1)
    .map(num => ({ value: num.toString(), label: num.toString() }));
  const incomeOptions = [
    { value: "0 - 25000", label: "0 - 25,000" },
    { value: "26000 - 50000", label: "26,000 - 50,000" },
    { value: "50000 - 100000", label: "50,000 - 100,000" },
    { value: "100000 - 250000", label: "100,000 - 250,000" },
    { value: "250000 - 500000", label: "250,000 - 500,000" },
    { value: "500000+", label: "500,000+" },
  ];
  const educationOptions = enumToOptions(enumData.education).map(opt =>
    opt.value === 'exception'
      ? { ...opt, label: 'Exception - Contact Admin for Approval' }
      : opt
  );
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };
  const setNumber = debounce((mobile) => {
    setFormData((prevData) => ({
      ...prevData,
      mobile: mobile,
    }));
  }, 300);
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ""
      }));
    }
    if (name === "image") {
      const file = files[0];
      if (file) {
        const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
        if (!allowedTypes.includes(file.type)) {
          toast.error("Only PNG, JPEG, and JPG formats are allowed.");
          return;
        }
        setFormData((prevData) => ({
          ...prevData,
          [name]: file,
        }));
      }
      return;
    }
    if (name === "dob") {
      const birthDate = new Date(value);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
        age: age.toString(),
      }));
    } else if (name === "title") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: type === "number" ? Number(value) : value,
        description: value,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: type === "number" ? Number(value) : value,
      }));
    }
  };
  const validateForm = () => {
    const requiredFields = [
      "first_name",
      "last_name",
      "email",
      "occupation",
      "show_name",
      "income",
      "gender",
      "title",
      "feet",
      "inch",
      "marital_status",
      "caste",
      "look",
      "education",
      "religion",
      "mobile",
      "you_are",
      "world_country_id",
      "world_division_id",
      "world_city_id",
      "dob",
    ];
    const newErrors = {};
    for (let field of requiredFields) {
      if (!formData[field] || formData[field] === "") {
        newErrors[field] = `${fieldLabels[field]} is required.`;
      }
    }
    if (formData.password !== formData.password_confirmation) {
      newErrors.password_confirmation = "Passwords do not match.";
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return false;
    }
    setErrors({});
    return true;
  };

  const submitRegistration = async () => {
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      if (
        formData[key] !== null &&
        formData[key] !== undefined &&
        formData[key] !== ""
      ) {
        formDataToSend.append(`user[${key}]`, formData[key]);
      }
    });

    try {
      const response = await baseURL.post(`/users`, formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("Registration Successful");
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (error) {
      console.error("Signup Error:", error.response?.data?.errors);
      toast.error(
        error.response?.data?.errors[0] || "Error signing up. Please try again."
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    // Show terms modal instead of directly submitting
    setShowTermsModal(true);
  };
  const handleTermsConfirm = () => {
    setShowTermsModal(false);
    submitRegistration();
  };

  const handleTermsClose = () => {
    setShowTermsModal(false);
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await baseURL.get("/get_all_countries");
        setCountries(response.data.countries);
      } catch (error) {
        console.error("Error fetching countries:", error);
        toast.error("Failed to load countries.");
      }
    };

    fetchCountries();
  }, []);
  useEffect(() => {
    const fetchRefferals = async () => {
      try {
        const response = await baseURL.get("/refferals");
        setRefferals(response.data.refferals);
      } catch (error) {
        console.error("Error fetching refferals:", error);
        toast.error("Failed to load refferals.");
      }
    };
    fetchRefferals();
  }, []);
  const handleCountryChange = async (e) => {
    const selectedCountry = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      world_country_id: selectedCountry,
      world_division_id: "",
      world_city_id: "",
    }));
    setErrors(prev => ({
      ...prev,
      world_country_id: "",
      world_division_id: "",
      world_city_id: ""
    }));
    try {
      const response = await baseURL.get(
        `/get_world_divisions/${selectedCountry}`
      );
      setDivisions(response.data.divisions);
    } catch (error) {
      console.error("Error fetching divisions:", error);
      toast.error("Failed to load divisions.");
    }
  };
  const handleDivisionChange = async (e) => {
    const selectedDivision = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      world_division_id: selectedDivision,
      world_city_id: "",
    }));
    setErrors(prev => ({
      ...prev,
      world_division_id: "",
      world_city_id: ""
    }));
    try {
      const response = await baseURL.get(`/get_all_cities/${selectedDivision}`);
      setCities(response.data.cities);
    } catch (error) {
      console.error("Error fetching cities:", error);
      toast.error("Failed to load cities.");
    }
  };
  const renderField = (key) => {
    if (key === "title") {
      return (
        <div key={key} className="mb-3 col-span-2">
          <label className="font-semibold text-[#730000] text-sm">
            {key.replace(/_/g, ' ').toUpperCase()}
            <font style={{ fontSize: "10px" }}> (See example below)</font>
          </label>
          <textarea
            name={key}
            value={formData[key]}
            onChange={handleChange}
            className={`w-full p-2 border rounded-md ${errors[key] ? 'border-red-500' : 'border-red-300'}`}
            rows="3"
            placeholder={
              "Must be detailed and extensive and inclusive of your details including your background / location and who you're seeking"
            }
          />
          {errors[key] && <div className="text-red-500 text-sm mt-1">{errors[key]}</div>}

          <label className="font-semibold text-[#730000] text-sm">EXAMPLE*</label>
          <textarea
            readOnly
            disabled
            className="w-full p-2 border border-red-300 rounded-md"
            rows="4"
            style={{ resize: "none" }}
            placeholder={
              "I am 26 years old. I am an MBBS doctor and a successful businessman. I have completed my Bachelors and Masters from USA and currently residing in DHA Lahore with my parents. I am seeking a highly educated and pious girl from a moderately religious family within Lahore. We are also open to abroad proposals."
            }
          />
        </div>
      );
    }

    if (key === "mobile") {
      return (
        <div className="mb-3 flex flex-col">
          <label className="font-semibold text-[#730000] mb-1 text-sm">
            MOBILE NUMBER
          </label>
          <IntlTelInput
            onChangeNumber={setNumber}
            initOptions={{
              initialCountry: "pk",
            }}
            className={`w-full p-2 border rounded-md ${errors[key] ? 'border-red-500' : 'border-red-300'}`}
          />
          {errors[key] && <div className="text-red-500 text-sm mt-1">{errors[key]}</div>}
        </div>
      );
    }

    if (key === "dob") {
      return (
        <div key={key} className="mb-3">
          <label className="font-semibold text-[#730000] text-sm">
            DATE OF BIRTH
          </label>
          <input
            type="date"
            name={key}
            value={formData[key]}
            onChange={handleChange}
            className={`w-full p-2 border rounded-md ${errors[key] ? 'border-red-500' : 'border-red-300'}`}
          />
          {errors[key] && <div className="text-red-500 text-sm mt-1">{errors[key]}</div>}
        </div>
      );
    }

    return (
      <div key={key} className="mb-3">
        <label className="font-semibold text-[#730000] text-sm">
          {key.replace(/_/g, ' ').toUpperCase()}
        </label>
        <input
          type="text"
          name={key}
          value={formData[key]}
          onChange={handleChange}
          className={`w-full p-2.5 border rounded-md ${errors[key] ? 'border-red-500' : 'border-red-300'}`}
        />
        {errors[key] && <div className="text-red-500 text-sm mt-1">{errors[key]}</div>}
      </div>
    );
  };

  return (
    <div className="relative">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <TermsModal
        isOpen={showTermsModal}
        onClose={handleTermsClose}
        onConfirm={handleTermsConfirm}
      />
      <div className="flex ">
        <Link to="/" className="absolute top-0 left-0 max-sm:top-1">
          <img src={logo1} className="w-24 h-24 max-md:w-20 max-md:h-20 max-sm:w-16 max-sm:h-16" />
        </Link>

        <h1 className="text-center max-md:text-2xl max-sm:text-xl flex justify-center items-center w-full text-[#760000]  font-semibold my-6 font-serif ">
          REGISTRATION
        </h1>
      </div>
      <div className={`w-full ${isHidden ? 'hidden' : ''}`} onAnimationEnd={handleAnimationEnd}>
        <img
          src={signup_image}
          alt="Banner"
          className={`w-full h-full object-cover bg-bottom ${startAnimation ? 'slide-up' : ''}`}
        />
      </div>
      {showForm && (
        <div className="form-container fade-in">
          <div className="font-serif gap-4 px-4 w-full container mx-auto">
            <div className="flex flex-col justify-center items-center bg-white">
              <form
                onSubmit={handleSubmit}
                className="bg-white rounded-lg py-4 w-full font-serif"
              >
                <h3 className="text-center text-lg font-semibold mb-6 font-serif ">
                  Basic Information
                </h3>
                <div className=" col-span-1 md:col-span-2">
                  {renderField("title")}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2 font-serif">
                  <div className="grid grid-cols-2 gap-2 max-md:grid-cols-1 ">
                    {renderField("first_name")}
                    {renderField("last_name")}
                  </div>
                  <div className="grid grid-cols-2 gap-2 max-md:grid-cols-1 ">
                    <div className="mb-3">
                      <SelectController
                        label="GENDER"
                        name="gender"
                        value={formData.gender}
                        onChange={handleChange}
                        options={enumToOptions(enumData.gender)}
                        error={errors.gender}
                      />
                    </div>
                    {renderField("dob")}
                  </div>
                  <div className="grid grid-cols-2 gap-2 max-md:grid-cols-1 ">
                    {renderField("email")}
                    {renderField("caste")}
                  </div>
                  <div className="grid grid-cols-2 gap-2 max-md:grid-cols-1 ">
                    <div className="mb-3">
                      <SelectController
                        label="OCCUPATION"
                        name="occupation"
                        value={formData.occupation}
                        onChange={handleChange}
                        options={enumToOptions(enumData.occupation)}
                        error={errors.occupation}
                      />
                    </div>
                    <div className="mb-3">
                      <SelectController
                        label="YOU ARE"
                        name="you_are"
                        value={formData.you_are}
                        onChange={handleChange}
                        options={enumToOptions(enumData.you_are)}
                        error={errors.you_are}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-2 max-md:grid-cols-1 ">
                    <div className="mb-3">
                      <SelectController
                        label="COUNTRY"
                        name="world_country_id"
                        value={formData.world_country_id}
                        onChange={handleCountryChange}
                        options={countries.map(country => ({
                          value: country.id,
                          label: country.name
                        }))}
                        error={errors.world_country_id}
                      />
                    </div>
                    <div className="mb-3">
                      <SelectController
                        label="STATE"
                        name="world_division_id"
                        value={formData.world_division_id}
                        onChange={handleDivisionChange}
                        options={divisions.map(division => ({
                          value: division.id,
                          label: division.name
                        }))}
                        disabled={!formData.world_country_id}
                        error={errors.world_division_id}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-2 max-md:grid-cols-1 ">
                    <div className="mb-3">
                      <SelectController
                        label="CITY"
                        name="world_city_id"
                        value={formData.world_city_id}
                        onChange={handleChange}
                        options={cities.map(city => ({
                          value: city.id,
                          label: city.name
                        }))}
                        disabled={!formData.world_division_id}
                        error={errors.world_city_id}
                      />
                    </div>
                    {renderField("mobile")}
                  </div>
                  <div className="mb-3">
                    <SelectController
                      label="MONTHLY INCOME (PKR)"
                      name="income"
                      value={formData.income}
                      onChange={handleChange}
                      options={incomeOptions}
                      error={errors.income}
                    />
                  </div>
                  <div className="mb-3">
                    <SelectController
                      label="SHOW NAME ON PLATFORM"
                      name="show_name"
                      value={formData.show_name}
                      onChange={handleChange}
                      options={enumToOptions(enumData.show_name)}
                      error={errors.show_name}
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-2 max-md:grid-cols-1 ">
                    <div className="mb-3">
                      <SelectController
                        label="MARITAL STATUS"
                        name="marital_status"
                        value={formData.marital_status}
                        onChange={handleChange}
                        options={enumToOptions(enumData.marital_status)}
                        error={errors.marital_status}
                      />
                    </div>
                    <div className="mb-3">
                      <SelectController
                        label="COMPLEXION"
                        name="look"
                        value={formData.look}
                        onChange={handleChange}
                        options={enumToOptions(enumData.look)}
                        error={errors.look}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-2 max-md:grid-cols-1 ">
                    <div className="mb-3">
                      <SelectController
                        label="EDUCATION"
                        name="education"
                        value={formData.education}
                        onChange={handleChange}
                        options={educationOptions}
                        error={errors.education}
                      />
                    </div>
                    <div className="mb-3">
                      <SelectController
                        label="RELIGION"
                        name="religion"
                        value={formData.religion}
                        onChange={handleChange}
                        options={enumToOptions(enumData.religion)}
                        error={errors.religion}
                      />
                    </div>
                  </div>
                  <div className="mb-3 flex gap-2">
                    <div className="flex-1">
                      <SelectController
                        label="HEIGHT (FEET)"
                        name="feet"
                        value={formData.feet}
                        onChange={handleChange}
                        options={feetOptions}
                        error={errors.feet}
                      />
                    </div>
                    <div className="flex-1">
                      <SelectController
                        label="HEIGHT (INCHES)"
                        name="inch"
                        value={formData.inch}
                        onChange={handleChange}
                        options={inchOptions}
                        error={errors.inch}
                      />
                    </div>
                  </div>
                  <div className="max-md:hidden">
                  </div>
                  <div className="mb-3">
                    <label className="font-semibold text-[#730000] text-sm">PASSWORD</label>
                    <input
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      className={`w-full p-2 border rounded-md ${errors.password ? 'border-red-500' : 'border-red-300'}`}
                    />
                    {errors.password && <div className="text-red-500 text-sm mt-1">{errors.password}</div>}
                  </div>
                  <div className="mb-3">
                    <label className="font-semibold text-[#730000] text-sm">
                      CONFIRM PASSWORD
                    </label>
                    <input
                      type="password"
                      name="password_confirmation"
                      value={formData.password_confirmation}
                      onChange={handleChange}
                      className={`w-full p-2 border rounded-md ${errors.password_confirmation ? 'border-red-500' : 'border-red-300'}`}
                    />
                    {errors.password_confirmation && <div className="text-red-500 text-sm mt-1">{errors.password_confirmation}</div>}
                  </div>
                </div>
                <div className="mt-5">
                  <button
                    type="submit"
                    className="bg-[#730000] text-white py-3 px-6 rounded-md font-semibold w-full text-lg hover:bg-[#5a0000] transition-colors"
                  >
                    Register
                  </button>
                </div>
                <div className="mt-5">
                  <SelectController
                    label="REFERRED BY"
                    name="referred_by"
                    value={formData.referred_by}
                    onChange={handleChange}
                    options={[
                      { value: "None", label: "None" },
                      ...refferals.map(ref => ({
                        value: ref.name,
                        label: ref.name
                      }))
                    ]}
                    error={errors.referred_by}
                  />
                </div>
                <p className="mt-4 text-center text-gray-600">
                  Already have an account?{" "}
                  <Link to="/login" className="text-[#730000] font-semibold hover:underline">
                    Sign In
                  </Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignUpScreen;